var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-tasklists", attrs: { id: "main" } },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content-wrapper" },
        [
          _c("div", { staticClass: "container-wrapper center" }, [
            _c(
              "h3",
              {
                staticClass:
                  "text-align-center col-12 margin-bottom-15 float-left override-padding"
              },
              [
                _vm.sub_tasklists_title.edit
                  ? _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.sub_tasklists_title.name,
                            expression: "sub_tasklists_title.name"
                          }
                        ],
                        staticClass:
                          "font-15 col-lg-8 col-sm-8 col-7 input-height-25",
                        attrs: { maxlength: "255" },
                        domProps: { value: _vm.sub_tasklists_title.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.sub_tasklists_title,
                              "name",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-blue col-lg-2 col-sm-2 col-3 input-height-25",
                          on: {
                            click: function($event) {
                              return _vm.updateSubTaskListAction()
                            }
                          }
                        },
                        [_c("b", [_vm._v("Save")])]
                      )
                    ])
                  : _c("div", [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.sub_tasklists_title.name) +
                          "\n        "
                      ),
                      _c("i", {
                        staticClass: "cursor-pointer fa fa-pencil-square-o",
                        staticStyle: { "font-size": "15px !important" },
                        attrs: { "aria-hidden": "true" },
                        on: {
                          click: function($event) {
                            _vm.sub_tasklists_title.edit = true
                          }
                        }
                      })
                    ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { clear: "both" } }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-lg-5 col-10 center text-align-center" },
              [
                _vm.addHeadingButtonShow
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-blue col-lg-5 col-5 input-height-35",
                        on: {
                          click: function($event) {
                            return _vm.HeadingClick()
                          }
                        }
                      },
                      [_vm._m(0)]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.addTaskButtonShow
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-blue col-lg-5 col-5 input-height-35",
                        on: {
                          click: function($event) {
                            return _vm.TaskClick()
                          }
                        }
                      },
                      [_vm._m(1)]
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.addHeadingShow,
                    expression: "addHeadingShow"
                  }
                ]
              },
              [
                _c("hr"),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.headings,
                      expression: "headings"
                    }
                  ],
                  ref: "headings",
                  staticClass: "col-lg-9 col-sm-9 col-12 input-height-35",
                  attrs: {
                    type: "text",
                    name: "headings",
                    id: "headings",
                    placeholder: "Enter Headings",
                    maxlength: "255"
                  },
                  domProps: { value: _vm.headings },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.headings = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-blue col-lg-2 col-sm-2 col-12 input-height-35",
                    on: { click: _vm.addHeadingsAction }
                  },
                  [_vm._m(2)]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { clear: "both" } }),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "heading_list" }, [
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "sortable",
                      rawName: "v-sortable",
                      value: { onEnd: _vm.reorderHeading, handle: ".handle1" },
                      expression: "{onEnd: reorderHeading, handle: '.handle1'}"
                    }
                  ],
                  staticClass: "counter_heading-list list-group col-lg-12"
                },
                _vm._l(_vm.sub_tasklist_obj.headings, function(heading, index) {
                  return _c(
                    "li",
                    {
                      key: heading.sortid,
                      staticClass: "list-group-item input-height-25"
                    },
                    [
                      _c("div", { staticClass: "heading_item" }, [
                        heading.edit
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "float-left col-lg-8 col-7 override-padding"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: heading.name,
                                      expression: "heading.name"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-8 col-sm-8 col-8 input-height-25",
                                  attrs: { maxlength: "255" },
                                  domProps: { value: heading.name },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        heading,
                                        "name",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-blue col-lg-2 col-sm-2 col-3 input-height-25",
                                    on: {
                                      click: function($event) {
                                        return _vm.updateHeadingsAction(heading)
                                      }
                                    }
                                  },
                                  [_c("b", [_vm._v("Save")])]
                                )
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "handle1 float-left col-lg-8 col-7 override-padding"
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-arrows padding-right-5",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "counter_heading-list__counter"
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(heading.name) +
                                    "\n            "
                                )
                              ]
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "float-left font-15 col-lg-1 col-1" },
                          [
                            _c("i", {
                              staticClass:
                                "cursor-pointer fa fa-pencil-square-o",
                              attrs: { "aria-hidden": "true" },
                              on: {
                                click: function($event) {
                                  heading.edit = true
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _vm.taskListStatus == "DRAFT"
                          ? _c(
                              "div",
                              {
                                staticClass: "float-left font-15 col-lg-1 col-1"
                              },
                              [
                                _c("i", {
                                  staticClass: "cursor-pointer fa fa-times",
                                  attrs: { "aria-hidden": "true" },
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteHeadingConfirm("", index)
                                    }
                                  }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "float-left font-15 col-lg-2 col-3" },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-action col-12 input-height-25",
                                on: {
                                  click: function($event) {
                                    return _vm.choose_tasks_redirect(index)
                                  }
                                }
                              },
                              [_vm._v(" Add Task")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticStyle: { clear: "both" } })
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("div", { staticClass: "task_container" }, [
                        _c("div", { staticStyle: { clear: "both" } }),
                        _vm._v(" "),
                        _c("div", { staticClass: "task_list" }, [
                          _c(
                            "ul",
                            {
                              directives: [
                                {
                                  name: "sortable",
                                  rawName: "v-sortable",
                                  value: {
                                    onEnd: _vm.reorderHeadingTasks,
                                    handle: ".handle2",
                                    group: {
                                      name: "heading-" + index,
                                      put: _vm.creategrouparray()
                                    }
                                  },
                                  expression:
                                    "{onEnd: reorderHeadingTasks, handle: '.handle2', group: { name: 'heading-' + index, put: creategrouparray() } }"
                                }
                              ],
                              staticClass:
                                "counter_task-list tasks_list list-group col-lg-12",
                              attrs: { "data-id": index }
                            },
                            _vm._l(heading.tasks, function(task, index1) {
                              return _c(
                                "li",
                                {
                                  key: task.sortid,
                                  staticClass: "list-group-item input-height-25"
                                },
                                [
                                  _c("div", { staticClass: "task_item" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "handle2 float-left col-lg-9 col-8 override-padding"
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa fa-arrows padding-right-5",
                                          attrs: { "aria-hidden": "true" }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass:
                                            "counter_task-list__counter"
                                        }),
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(task.name) +
                                            "\n                     "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "float-left col-lg-2 col-3 override-padding"
                                      },
                                      [
                                        task.priority > 0
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                        P" +
                                                  _vm._s(task.priority) +
                                                  "\n                      "
                                              )
                                            ])
                                          : _c("span", [_vm._v(" ")])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "float-left font-15 col-lg-1 col-1 override-padding"
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "cursor-pointer fa fa-times",
                                          attrs: { "aria-hidden": "true" },
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteHeadingTasksConfirm(
                                                index,
                                                index1
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticStyle: { clear: "both" } })
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      ])
                    ]
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _vm.sub_tasklist_obj.tasks.length > 0
              ? _c("div", { staticClass: "subtask_task_list" }, [
                  _c(
                    "ul",
                    {
                      directives: [
                        {
                          name: "sortable",
                          rawName: "v-sortable",
                          value: { onEnd: _vm.reorderTask, handle: ".handle3" },
                          expression: "{onEnd: reorderTask, handle: '.handle3'}"
                        }
                      ],
                      staticClass: "counter_task-list col-lg-12"
                    },
                    _vm._l(_vm.sub_tasklist_obj.tasks, function(task, index2) {
                      return _c(
                        "li",
                        { key: task.sortid, staticClass: "input-height-25" },
                        [
                          _c("div", { staticClass: "task_item" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "handle3 float-left col-lg-9 col-8 override-padding"
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-arrows padding-right-5",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "counter_task-list__counter"
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(task.name) +
                                    "\n             "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "float-left col-lg-2 col-3 override-padding"
                              },
                              [
                                task.priority > 0
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                  P" +
                                          _vm._s(task.priority) +
                                          "\n               "
                                      )
                                    ])
                                  : _c("span", [_vm._v(" ")])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "float-left font-15 col-lg-1 col-1 override-padding"
                              },
                              [
                                _c("i", {
                                  staticClass: "cursor-pointer fa fa-times",
                                  attrs: { "aria-hidden": "true" },
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteHeadingTasksConfirm(
                                        "",
                                        index2
                                      )
                                    }
                                  }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticStyle: { clear: "both" } })
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", {
              staticClass: "margin-bottom-20",
              staticStyle: { clear: "both" }
            }),
            _vm._v(" "),
            this.sub_tasklist_obj.headings.length > 0 ||
            this.sub_tasklist_obj.tasks.length > 0 ||
            this.sub_tasklist_obj.remove_headings.headings.length > 0 ||
            this.sub_tasklist_obj.remove_tasks.length > 0
              ? _c(
                  "div",
                  {
                    staticClass:
                      "submit float-right col-lg-2 col-4 override-padding",
                    on: { click: _vm.onSubmit }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "col-12 btn btn-info btn-md input-height-35",
                        attrs: { type: "submit" }
                      },
                      [_vm._v("Save List")]
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "margin-bottom-20",
            staticStyle: { clear: "both" }
          }),
          _vm._v(" "),
          _c(
            "DeleteModal",
            {
              attrs: {
                isModalVisible: _vm.isModalVisible,
                id: _vm.id,
                parent_id: _vm.parent_id
              },
              on: {
                close: function($event) {
                  _vm.isModalVisible = false
                }
              }
            },
            [
              _vm.loading
                ? _c("span", { staticClass: "pull-right text-danger" }, [
                    _vm._v("\n      Loading...\n    ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "sub-heading",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [_vm._v("Are you sure want to Delete?")]
              ),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-3 override-padding",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "left col-12 btn btn-blue",
                      on: {
                        click: function($event) {
                          _vm.isModalVisible = false
                          _vm.deleteHeadingTasksAction(_vm.id, _vm.parent_id)
                        }
                      }
                    },
                    [_vm._v("Confirm")]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "DeleteModal",
            {
              attrs: {
                isModalVisible: _vm.isDeleteModalVisible,
                id: _vm.id,
                parent_id: _vm.parent_id
              },
              on: {
                close: function($event) {
                  _vm.isDeleteModalVisible = false
                }
              }
            },
            [
              _vm.loading
                ? _c("span", { staticClass: "pull-right text-danger" }, [
                    _vm._v("\n      Loading...\n    ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "sub-heading",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [
                  _vm._v(
                    "Are you sure want to Delete? This will delete tasks related."
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-3 override-padding",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "left col-12 btn btn-blue",
                      on: {
                        click: function($event) {
                          _vm.isDeleteModalVisible = false
                          _vm.deleteHeadingAction(_vm.id, _vm.parent_id)
                        }
                      }
                    },
                    [_vm._v("Confirm")]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "ValidationModal",
            {
              attrs: { isModalVisible: _vm.isValidationModalVisible },
              on: {
                close: function($event) {
                  _vm.isValidationModalVisible = false
                }
              }
            },
            [
              _vm.loading
                ? _c("span", { staticClass: "pull-right text-danger" }, [
                    _vm._v("\n      Loading...\n    ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "sub-heading",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [_vm._v("Please enter heading title")]
              ),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }),
              _vm._v(" "),
              _c("div", {
                staticClass: "col-3 override-padding",
                attrs: { slot: "footer" },
                slot: "footer"
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "ValidationModal",
            {
              attrs: { isModalVisible: _vm.isInfoModalVisible },
              on: {
                close: function($event) {
                  _vm.isInfoModalVisible = false
                }
              }
            },
            [
              _vm.loading
                ? _c("span", { staticClass: "pull-right text-danger" }, [
                    _vm._v("\n      Loading...\n    ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "sub-heading",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [
                  _vm._v(
                    "The task shouldn't be removed because it has assessments."
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }),
              _vm._v(" "),
              _c("div", {
                staticClass: "col-3 override-padding",
                attrs: { slot: "footer" },
                slot: "footer"
              })
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _c("i", { staticClass: "fa fa-plus", attrs: { "aria-hidden": "true" } }),
      _vm._v(" Add Headings")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _c("i", { staticClass: "fa fa-plus", attrs: { "aria-hidden": "true" } }),
      _vm._v(" Add Task")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _c("i", { staticClass: "fa fa-plus", attrs: { "aria-hidden": "true" } }),
      _vm._v(" Add Headings")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fa4da7fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa4da7fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/create_headings_tasks.vue
// module id = null
// module chunks = 